// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e75b307e","977":"a1c0fa4b"}[chunkId] + ".chunk.js";
};